import { render, staticRenderFns } from "./releaseNoteForm.vue?vue&type=template&id=3adaa94f"
import script from "./releaseNoteForm.vue?vue&type=script&lang=js"
export * from "./releaseNoteForm.vue?vue&type=script&lang=js"
import style0 from "./releaseNoteForm.vue?vue&type=style&index=0&id=3adaa94f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports